module.exports = __webpack_public_path__ + "static/80x80-07b82d5a149176c5ea2a1e44f179e3ea.svg";